import { z } from 'zod';

// Login validation schema
export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

// Role validation schema
export const roleSchema = z.object({
  name: z.string().min(1, 'Role name is required').max(50, 'Role name cannot exceed 50 characters'),
  description: z.string().min(1, 'Description is required'),
  permission_ids: z.array(z.string()).default([]),
  visible_page_paths: z.array(z.string()).min(1, 'Select at least one page'),
});

export type RoleFormData = z.infer<typeof roleSchema>;

// Utility functions for form error handling
export const getFormErrorMessage = (error: any, defaultMessage: string): string => {
  if (error?.data?.detail) {
    return error.data.detail;
  }
  if (error?.data?.non_field_errors?.length > 0) {
    return error.data.non_field_errors[0];
  }
  return defaultMessage;
};

export const getFieldErrors = (error: any): Record<string, string> => {
  const fieldErrors: Record<string, string> = {};
  
  if (error?.data && typeof error.data === 'object') {
    Object.entries(error.data).forEach(([field, messages]) => {
      if (field !== 'detail' && field !== 'non_field_errors' && Array.isArray(messages)) {
        fieldErrors[field] = messages[0];
      }
    });
  }
  
  return fieldErrors;
};
